module.exports = __webpack_public_path__ + "img/map-station-EN.0e88e554.png";